<!--资料库-->
<template>
  <div class="dataBase-layer">
    <div class="container">
      <div class="leftbox">
        <div class="toptitle">目录</div>
        <div class="nav">
          <el-menu class="abcd-text" style="
          height: 100%;
          width: 100%;
          overflow: auto;
          border-right: solid 1px #e6e6e6;
        " default-active="1-1" :default-openeds="childArr" background-color="#fff" text-color="#000000"
                   active-text-color="#fff" @select="slideSelect">
            <!-- 一级菜单 -->
            <template v-for="item in list">
              <el-submenu v-if="item.children && item.children.length" :index="item.path" :key="item.path">
                <template slot="title"><i :class="item.icon"></i><span>{{ item.name }}</span></template>

                <!-- 二级菜单 -->
                <template v-for="itemChild in item.children">
                  <el-submenu v-if="itemChild.children && itemChild.children.length" :index="itemChild.path"
                              :key="itemChild.path">
                    <template slot="title"><i :class="itemChild.icon"></i><span>{{ itemChild.name }}</span></template>

                    <!-- 三级菜单 -->
                    <!-- <el-menu-item v-for="itemChild_Child in itemChild.children" :index="itemChild_Child.path"
                                  :key="itemChild_Child.path" @click.native="
                                    setPath(itemChild_Child, itemChild_Child.path, key, $event)
                                    ">
                      <i :class="itemChild_Child.icon"></i><span slot="title">{{
                        itemChild_Child.name
                      }}</span></el-menu-item> -->

                    <template v-for="itemChild_Child in itemChild.children">
                      <template v-if="itemChild_Child.children">
                        <el-submenu :index="itemChild_Child.path" :key="itemChild_Child.path">
                          <template slot="title"><i :class="itemChild_Child.icon"></i><span>{{
                            itemChild_Child.name
                          }}</span></template>
                          <el-menu-item v-for="itemChild_Child_Child in itemChild_Child.children"
                                        :index="itemChild_Child_Child.path" :key="itemChild_Child_Child.path"
                                        @click.native="
                                          setPath(itemChild_Child_Child, itemChild_Child_Child.path, key, $event)
                                          ">
                            <i :class="itemChild_Child_Child.icon"></i><span slot="title">{{
                              itemChild_Child_Child.name
                            }}</span></el-menu-item>
                        </el-submenu>

                      </template>
                      <!-- 如果第三层没有子菜单 -->
                      <el-menu-item v-else :index="itemChild_Child.path" :key="itemChild_Child.path" @click.native="
                        setPath(itemChild_Child, itemChild_Child.path, key, $event)
                        "><i :class="itemChild_Child.icon"></i><span slot="title">{{
                          itemChild_Child.name }}</span></el-menu-item>
                    </template>

                    <!--结束-->

                  </el-submenu>

                  <el-menu-item v-else :index="itemChild.path" :key="itemChild.path"><i
                       :class="itemChild.icon"></i><span slot="title">{{
                        itemChild.name }}</span></el-menu-item>
                </template>
              </el-submenu>

              <el-menu-item @click.native="
                setPath(item, item.path, key, $event)
                " v-else :index="item.path" :key="item.path"><i :class="item.icon"></i><span slot="title">{{
                  item.name }}</span></el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
      <div class="rightbox">
        <!-- <div v-if="sourceurl == ''"
             style="display: flex;justify-content: center;align-items: center;font-size: 18px;height: 100%;">
          暂无资源
        </div> -->
        <PDFReader ref="PDFReader" :mode="2" @onload="onLoaded" @change="onPDFChange">
        </PDFReader>
      </div>
    </div>
  </div>
</template>

<script>
import PDFReader from '@/components/PDFReader'
export default {
  name: '',
  components: { PDFReader },
  props: {},
  data () {
    return {
      list: [
        {
          path: "1",
          name: "1.快速了解FastGPT",
          icon: "el-icon-news",
          filepath: '/快速了解DyGPT.pdf'
        },
        {
          path: "2",
          name: "2.功能介绍",
          icon: "el-icon-document-copy",
          children: [
            {
              path: "2-1",
              name: "2.1基础教程",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "2-1-1",
                  name: "2.1.1快速上手",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍-快速上手.pdf'
                },
                {
                  path: "2-1-2",
                  name: "2.1.2AI相关参数配置说明",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍-2AI 相关参数配置说明.pdf'
                },
                {
                  path: "2-1-3",
                  name: "2.1.3对话问题引导",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍3--对话问题引导.pdf'
                },
                {
                  path: "2-1-4",
                  name: "2.1.4知识库集合标签",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍4-知识库集合标签.pdf'
                },
                {
                  path: "2-1-5",
                  name: "2.1.5文件输入功能介绍",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍5--文件输入功能介绍.pdf'
                },
              ],
            },
            {
              path: "2-2",
              name: "2.2工作台",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "2-2-1",
                  name: "2.2.1简易模式",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍-简易版本.pdf'
                },
                {
                  path: "2-2-2",
                  name: "2.2.2工作流&插件",
                  icon: "el-icon-menu",
                  filepath: '/功能介绍-工作流插件.pdf'
                },
                {
                  path: "2-2-3",
                  name: "2.2.3工作流节点",
                  icon: "el-icon-menu",
                  // filepath: ''
                  children: [
                    {
                      path: "2-2-3-1",
                      name: "2.2.3.1AI对话",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-AI 对话.pdf'
                    },
                    {
                      path: "2-2-3-2",
                      name: "2.2.3.2知识库搜索",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-知识库搜索.pdf'
                    },
                    {
                      path: "2-2-3-3",
                      name: "2.2.3.3工具调用&终止",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-4",
                      name: "2.2.3.4问题分类",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-工作台-工作流节点-问题分类.pdf'
                    },
                    {
                      path: "2-2-3-5",
                      name: "2.2.3.5文本内容提取",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-工作台-工作流节点-文本内容提取.pdf'
                    },
                    {
                      path: "2-2-3-6",
                      name: "2.2.3.6用户选择",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-工作台工作流节点-用户选择.pdf'
                    },
                    {
                      path: "2-2-3-7",
                      name: "2.2.3.7表单输入",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-工作台-工作流节点-表单输入.pdf'
                    },
                    {
                      path: "2-2-3-8",
                      name: "2.2.3.8文本拼接",
                      icon: "el-icon-menu",
                      filepath: '/功能介绍-工作台工作流节点-文本拼接.pdf'
                    },
                    {
                      path: "2-2-3-9",
                      name: "2.2.3.9指定回复",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-10",
                      name: "2.2.3.10文档解析",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-11",
                      name: "2.2.3.11HTTP请求",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-12",
                      name: "2.2.3.12判断器",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-13",
                      name: "2.2.3.13变量更新",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-14",
                      name: "2.2.3.14代码运行",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-15",
                      name: "2.2.3.15批量运行",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-16",
                      name: "2.2.3.16知识库搜索引用合并",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-17",
                      name: "2.2.3.17问题优化",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-18",
                      name: "2.2.3.18Laf函数调用",
                      icon: "el-icon-menu",
                      filepath: ''
                    },
                    {
                      path: "2-2-3-19",
                      name: "2.2.3.19自定义反馈",
                      icon: "el-icon-menu",
                      filepath: ''
                    }
                  ],
                },
                {
                  path: "2-2-4",
                  name: "2.2.4MCP服务",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-2-5",
                  name: "2.2.5MCP工具集",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-2-6",
                  name: "2.2.6使用Gapier快速导入Agent工具",
                  icon: "el-icon-menu",
                  filepath: ''
                },
              ],
            },
            {
              path: "2-3",
              name: "2.3系统插件",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "2-3-1",
                  name: "2.3.1如何提交系统插件",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-3-2",
                  name: "2.3.2SearXNG搜索插件配置与使用说明",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-3-3",
                  name: "2.3.3Google搜索插件填写说明",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-3-4",
                  name: "2.3.4Bing搜索插件填写说明",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-3-5",
                  name: "2.3.5Doc2x插件填写说明",
                  icon: "el-icon-menu",
                  filepath: ''
                }
              ],
            },
            {
              path: "2-4",
              name: "2.4知识库",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "2-4-1",
                  name: "2.4.1知识库基础原理介绍",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-2",
                  name: "2.3.2知识库搜索方案和参数",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-3",
                  name: "2.4.3API文件库",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-4",
                  name: "2.4.4飞书知识库",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-5",
                  name: "2.4.5语雀文件库",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-6",
                  name: "2.4.6Web站点同步",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-7",
                  name: "2.4.7外部文件知识库",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-8",
                  name: "2.4.8第三方知识库开发",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-4-9",
                  name: "2.4.9模板导入",
                  icon: "el-icon-menu",
                  filepath: ''
                },
              ],
            },
            {
              path: "2-5",
              name: "2-5对话框",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "2-5-1",
                  name: "2-5.1对话框与HTML渲染",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "2-5-2",
                  name: "2-5.2知识库引用分块阅读器",
                  icon: "el-icon-menu",
                  filepath: ''
                },
              ],
            },

          ],
        },
        {
          path: "3",
          name: "3.使用案例",
          icon: "el-icon-notebook-1",
          children: [
            {
              path: "3-1",
              name: "3.1外部调用DYGPT",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "3-1-1",
                  name: "3.1.1通过API访问应用",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-2",
                  name: "3.1.2接入飞书机器人教程",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-3",
                  name: "3.1.3接入钉钉机器人教程",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-4",
                  name: "3.1.4接入微信公众号教程",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-5",
                  name: "3.1.5对接chatgpt-on-wechat",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-6",
                  name: "3.1.6接入微信和企业微信",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-1-7",
                  name: "3.1.7iframe接入",
                  icon: "el-icon-menu",
                  filepath: ''
                }
              ],
            },
            {
              path: "3-2",
              name: "3.2应用搭建案例",
              icon: "el-icon-tickets",
              children: [
                {
                  path: "3-2-1",
                  name: "3.2.1如何提交应用模版",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-2",
                  name: "3.2.2长字幕翻译",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-3",
                  name: "3.2.3多轮翻译机器人",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-4",
                  name: "3.2.4英语作文纠错机器人",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-5",
                  name: "3.2.5固定开头和结尾内容",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-6",
                  name: "3.2.6实验室预约",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-7",
                  name: "3.2.7Dalle3绘图",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-8",
                  name: "3.2.8接入谷歌搜索",
                  icon: "el-icon-menu",
                  filepath: ''
                },
                {
                  path: "3-2-9",
                  name: "3.2.9发送飞书webhook通知",
                  icon: "el-icon-menu",
                  filepath: ''
                }
              ],
            },
          ],
        },
      ],
      activeIndex: "1-1",
      childArr: ["1", "2", "3", "2-1", "2-2"],
      sourceurl: ''
    }
  },
  computed: {},
  watch: {},
  created () {
    //默认展示第一个pdf
    const data = {
      path: "1",
      name: "1.快速了解FastGPT",
      icon: "el-icon-news",
      filepath: '/快速了解DyGPT.pdf'
    }
    this.setPath(data)
  },
  mounted () { },
  methods: {
    slideSelect (key, keyPath, item) {
      console.log(key, keyPath, item);
      this.activeIndex = key;
    },
    setPath (item, key, index, even) {
      this.$nextTick(() => {
        if (item.filepath) {
          this.sourceurl = item.filepath
          this.$refs.PDFReader.loadFile(this.sourceurl)
        } else {
          this.sourceurl = ''
        }
        // let sourceurl = '/功能介绍-快速上手.pdf'
        // this.$refs.PDFReader.loadFile(sourceurl)
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-menu-item.is-active {
  color: #4568f6 !important;
}

.dataBase-layer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    width: 13.66rem;
    height: calc(100% - 0.6rem);
    margin: 0.3rem;
    border-radius: 0.15rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    .leftbox {
      width: 3.4rem;
      height: 90%;
      border-right: 1px solid #EBEBEB;

      .toptitle {
        height: 0.3rem;
        font-size: 16px;
        margin-left: 0.2rem;
      }

      .nav {
        height: calc(100% - 0.3rem);

      }
    }

    .rightbox {
      width: calc(100% - 3.4rem);
      height: 90%;
    }
  }
}
</style>
